import * as React from 'react'
import { TitlePageWrapper } from './title-page.styles'
import TitlePageProps from './title-page.interfaces'

const TitlePage = ({ titlePage }: TitlePageProps) => {
	return <TitlePageWrapper variant="h1">{titlePage}</TitlePageWrapper>
}

export default TitlePage
